import React, { useEffect, useState } from 'react';
interface AdvisoryHeaderProps {
  openContactForm: () => void;
}
export function AdvisoryHeader({
  openContactForm
}: AdvisoryHeaderProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const href = e.currentTarget.getAttribute('href');
    if (href && href.startsWith('#')) {
      const targetId = href.substring(1);
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        setMobileMenuOpen(false);
      }
    }
  };
  const navItems = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Results',
    href: '#case-studies'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <header className={`w-full py-4 px-6 md:px-12 lg:px-16 flex justify-between items-center fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-navy-900/95 backdrop-blur-md border-b border-slate-800/50' : 'bg-transparent'}`} data-id="element-75">
      <a href="/" className="flex items-center" data-id="element-76">
        <img src="https://cdn.magicpatterns.com/uploads/xiJX1BNGuywsLcQCuy8Sr8/ironsmith_advisors_logo.png" alt="Ironsmith Advisors" className="h-10 sm:h-12 w-auto" data-id="element-77" />
      </a>

      <nav className="hidden md:flex items-center gap-8 lg:gap-10" data-id="element-78">
        {navItems.map(item => <a key={item.name} href={item.href} className="text-slate-300 hover:text-white transition-colors duration-200 text-[14px] font-medium" onClick={handleSmoothScroll} data-id="element-79">
            {item.name}
          </a>)}
        <a href="https://calendar.app.google/QG1eQrZMQfAuXDhF8" target="_blank" rel="noopener noreferrer" className="bg-gold-500 text-navy-900 px-5 py-2.5 rounded font-semibold hover:bg-gold-400 transition-colors duration-200 text-[13px]" data-id="element-80">
          Book a Call
        </a>
      </nav>

      <button className="md:hidden p-2 text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-81">
        <div className={`w-5 h-0.5 bg-current transition-all duration-200 ${mobileMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`} data-id="element-82" />
        <div className={`w-5 h-0.5 bg-current my-1 transition-all duration-200 ${mobileMenuOpen ? 'opacity-0' : ''}`} data-id="element-83" />
        <div className={`w-5 h-0.5 bg-current transition-all duration-200 ${mobileMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`} data-id="element-84" />
      </button>

      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-navy-900/98 backdrop-blur-md py-6 px-6 md:hidden border-t border-slate-800/50" data-id="element-85">
          <nav className="flex flex-col gap-1" data-id="element-86">
            {navItems.map(item => <a key={item.name} href={item.href} className="text-slate-300 hover:text-white transition-colors duration-200 py-3 text-base font-medium" onClick={handleSmoothScroll} data-id="element-87">
                {item.name}
              </a>)}
            <a href="https://calendar.app.google/QG1eQrZMQfAuXDhF8" target="_blank" rel="noopener noreferrer" className="bg-gold-500 text-navy-900 w-full py-3 rounded font-semibold hover:bg-gold-400 transition-colors duration-200 mt-4 block text-center" onClick={() => setMobileMenuOpen(false)} data-id="element-88">
              Book a Call
            </a>
          </nav>
        </div>}
    </header>;
}